import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import { blogService } from '../../services/blogService';
import config from '../../config/config';

const BlogList = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const data = await blogService.getAdminBlogs();
      setBlogs(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching blogs:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      try {
        await blogService.deleteBlog(id);
        setBlogs(blogs.filter(blog => blog._id !== id));
      } catch (error) {
        console.error('Error deleting blog:', error);
        alert('Error deleting blog');
      }
    }
  };

  if (loading) {
    return (
        <div className="flex items-center justify-center h-screen">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-orange-500"></div>
        </div>
    );
  }

  return (
      <div className="p-6">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-bold text-white">Blog Posts</h1>
          <button
            onClick={() => navigate('/admin/blogs/new')}
            className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          >
            Create New Post
          </button>
        </div>

        <div className="grid gap-6">
          {blogs.map((blog) => (
            <div
              key={blog._id}
              className="bg-[#1a1a1a] rounded-xl border border-zinc-800 p-6 flex items-center justify-between"
            >
              <div className="flex items-center space-x-4">
                {blog.featuredImage && (
                  <img
                    src={`${config.API_BASE_URL}${blog.featuredImage}`}
                    alt={blog.title}
                    className="w-16 h-16 object-cover rounded-lg"
                  />
                )}
                <div>
                  <h2 className="text-xl font-semibold text-white">{blog.title}</h2>
                  <div className="flex items-center mt-2 space-x-4">
                    <span className="text-sm text-zinc-400">
                      By {blog.author || 'Anonymous'}
                    </span>
                    <span className="text-sm px-2 py-1 rounded-full bg-zinc-800 text-zinc-400">
                      {blog.status}
                    </span>
                    {blog.tags && blog.tags.length > 0 && (
                      <div className="flex items-center space-x-2">
                        {blog.tags.map((tag, index) => (
                          <span
                            key={index}
                            className="text-sm px-2 py-1 rounded-full bg-zinc-800 text-zinc-400"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => navigate(`/admin/blogs/${blog.id}/edit`)}
                  className="px-4 py-2 text-zinc-400 hover:text-white hover:bg-zinc-800/50 rounded-lg transition-colors"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(blog.id)}
                  className="px-4 py-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-colors"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}

          {blogs.length === 0 && (
            <div className="text-center py-12">
              <p className="text-zinc-400">No blog posts found. Create your first post!</p>
            </div>
          )}
        </div>
      </div>
  );
};

export default BlogList;
